// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/low-flying-precautions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/low-flying-precautions/low-flying-precautions.js';

mount([g0]);
